(() => {
  const ID = 'gigi-product-social-proof';
  const SHIPPING_ID = 'gigi-shipping-estimate';
  const FRESH_MS = 30 * 60 * 60 * 1000;

  function proofData() {
    const source = window.gigiProductSocialProof || {};
    return {
      sales48h: Number(source.sales48h || 0),
      sales7d: Number(source.sales7d || 0),
      updatedAt: source.updatedAt || null,
      mostChosen: source.mostChosen === true
    };
  }

  function isFresh(updatedAt) {
    const timestamp = Date.parse(updatedAt || '');
    if (!Number.isFinite(timestamp)) return false;
    const age = Date.now() - timestamp;
    return age >= -5 * 60 * 1000 && age <= FRESH_MS;
  }

  function getMessage(data) {
    const fresh = isFresh(data.updatedAt);

    if (fresh && data.sales48h >= 2) {
      return {
        kind: 'fast',
        icon: '✦',
        html: `<strong>${data.sales48h} compras</strong> en las últimas 48 horas`
      };
    }

    if (fresh && data.sales7d >= 3) {
      return {
        kind: 'week',
        icon: '♡',
        html: `<strong>${data.sales7d} compras</strong> en los últimos 7 días`
      };
    }

    if (data.mostChosen) {
      return {
        kind: 'chosen',
        icon: '♡',
        html: 'Entre los más elegidos por nuestras clientas'
      };
    }

    return null;
  }

  function render() {
    const shipping = document.getElementById(SHIPPING_ID);
    if (!shipping) return false;

    const message = getMessage(proofData());
    let element = document.getElementById(ID);

    if (!message) {
      element?.remove();
      return true;
    }

    if (!element) {
      element = document.createElement('div');
      element.id = ID;
      element.setAttribute('role', 'note');
      element.setAttribute('aria-label', 'Popularidad reciente del producto');
    }

    element.className = `gigi-product-social-proof gigi-product-social-proof--${message.kind}`;
    element.innerHTML = `<span class="gigi-product-social-proof__icon" aria-hidden="true">${message.icon}</span><span class="gigi-product-social-proof__text">${message.html}</span>`;

    if (element.previousElementSibling !== shipping) {
      shipping.insertAdjacentElement('afterend', element);
    }

    return true;
  }

  function installWithRetry() {
    if (render()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (render() || attempts >= 30) window.clearInterval(timer);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installWithRetry, { once: true });
  } else {
    installWithRetry();
  }

  window.addEventListener('pageshow', installWithRetry);
  document.addEventListener('shopify:section:load', () => window.setTimeout(installWithRetry, 0));
})();
